export function decodeError(error) {
  if (error.response) {
    const { status, statusText, data } = error.response;

    const message = extractMessageFromData(data) || `${status} - ${statusText}`;

    return {
      status,
      message
    };
  }
  return {
    message: error.message || 'Unknown error'
  };
}

const HTML_CONTENT = '<!DOCTYPE';
const SERVICE_TAG = '[OrbServiceLibrary]';
const TRAIL_TAG = '<p>';

function extractMessageFromData(data) {
  let message = data;
  if (message.startsWith(HTML_CONTENT)) {
    return null;
  }

  const serviceIndex = message.indexOf(SERVICE_TAG);
  if (serviceIndex !== -1) {
    message = message.substring(serviceIndex + SERVICE_TAG.length);

    const trailIndex = message.indexOf(TRAIL_TAG);
    if (trailIndex !== -1) {
      message = message.substring(0, trailIndex);
    }
  }

  return message.trim();
}



// WEBPACK FOOTER //
// ./src/utility/errors.js